import { NotificationService } from "../NotificationService";
import { WizardViewMode } from "./WizardViewMode";

export class AuthenticationMethodWizardViewModel {
    constructor(options) {
        this.createMfaAppAuthenticationMethodUrl = options.createMfaAppAuthenticationMethodUrl;
        this.confirmMfaAppAuthenticationMethodUrl = options.confirmMfaAppAuthenticationMethodUrl;

        this.rootElement = options.$rootElement;

        this.notificationService = new NotificationService();

        this.appCode.subscribe(() => {
            this.isInvalidCode(false);
        });

        this.methodName.subscribe(() => this.qrCodeImageUrl(null));
    }

    wizardViewMode: KnockoutObservable<WizardViewMode> = ko.observable(WizardViewMode.EnterMethodName);
    rootElement: JQuery;
    onSaveComplete: (data: any) => void;

    createMfaAppAuthenticationMethodUrl: string;
    confirmMfaAppAuthenticationMethodUrl: string;

    methodName = ko.observable(null).extend({ required: true });
    accountName = ko.observable(null);
    secretKey = ko.observable(null);
    methodConfirmationId = ko.observable(null);
    qrCodeImageUrl = ko.observable(null);
    showContainerCodes = ko.observable(false);
    isInvalidCode = ko.observable(false);
    isInputSelected = ko.observable(true);

    appCode = ko.observable(null)
        .extend({
            required: true,
            minLength: 6,
            maxLength: 6,
            validation: [
                {
                    validator: () => this.isInvalidCode() === false,
                    message: "Invalid Code."
                }
            ]
        });

    canViewAddMethodName: KnockoutComputed<boolean> = ko.pureComputed({
        read: () => this.wizardViewMode() === WizardViewMode.EnterMethodName,
        deferEvaluation: true
    });

    canViewinformation: KnockoutComputed<boolean> = ko.pureComputed({
        read: () => this.wizardViewMode() === WizardViewMode.Information,
        deferEvaluation: true
    });

    canViewScanCode: KnockoutComputed<boolean> = ko.pureComputed({
        read: () => this.wizardViewMode() === WizardViewMode.ScanCode,
        deferEvaluation: true
    });

    canViewEnterCode: KnockoutComputed<boolean> = ko.pureComputed({
        read: () => this.wizardViewMode() === WizardViewMode.EnterCode,
        deferEvaluation: true
    });

    showClipboardAccountName: KnockoutComputed<boolean> = ko.pureComputed({
        read: () => this.accountName(),
        deferEvaluation: true
    });

    showClipboardSecretKey: KnockoutComputed<boolean> = ko.pureComputed({
        read: () => this.secretKey(),
        deferEvaluation: true
    });

    backButtonView: KnockoutComputed<boolean> = ko.pureComputed({
        read: () => {
            switch (this.wizardViewMode()) {
                case WizardViewMode.Information:
                case WizardViewMode.ScanCode:
                case WizardViewMode.EnterCode:
                    return true;
                default: return false;
            }
        },
        deferEvaluation: true
    });

    nextButtonView: KnockoutComputed<boolean> = ko.pureComputed({
        read: () => {
            switch (this.wizardViewMode()) {
                case WizardViewMode.EnterMethodName:
                case WizardViewMode.Information:
                case WizardViewMode.ScanCode:
                    return true;
                default: return false;
            }
        },
        deferEvaluation: true
    });

    disableFinish: KnockoutComputed<boolean> = ko.pureComputed({
        read: () => !this.validate(),
        deferEvaluation: true
    });

    disableGotoNext: KnockoutComputed<boolean> = ko.pureComputed({
        read: () => {
            switch (this.wizardViewMode()) {
                case WizardViewMode.EnterMethodName:
                    return !this.methodName.isValid();
                default: return false;
            }
        },
        deferEvaluation: true
    });

    private readonly notificationService: NotificationService;

    clear() {
        this.wizardViewMode(WizardViewMode.EnterMethodName);
        this.methodName(null);
        this.accountName(null);
        this.secretKey(null);
        this.appCode(null);
        this.qrCodeImageUrl(null);
        this.showContainerCodes(false);

        this.clearValidation();
    }

    gotoBack() {
        switch (this.wizardViewMode()) {
            case WizardViewMode.Information:
                this.wizardViewMode(WizardViewMode.EnterMethodName);
                break;
            case WizardViewMode.ScanCode:
                this.wizardViewMode(WizardViewMode.Information);
                break;
            case WizardViewMode.EnterCode:
                this.wizardViewMode(WizardViewMode.ScanCode);
                break;
        }
        this.isInputSelected(true);
    }

    gotoNext() {
        switch (this.wizardViewMode()) {
            case WizardViewMode.EnterMethodName:
                this.wizardViewMode(WizardViewMode.Information);
                break;
            case WizardViewMode.Information:
                const switchPage = () => this.wizardViewMode(WizardViewMode.ScanCode);

                if (!this.qrCodeImageUrl()) {
                    this.generateKey(switchPage);
                } else {
                    switchPage();
                }
                break;
            case WizardViewMode.ScanCode:
                this.wizardViewMode(WizardViewMode.EnterCode);
                break;
        }
        this.isInputSelected(true);
    }

    addMethod(callback: any) {
        this.clear();
        this.onSaveComplete = callback;
        (this.rootElement as any).appendTo("body").modal('show');
        this.isInputSelected(true);
    }

    confirmMethod() {
        $.ajax({
            url: this.confirmMfaAppAuthenticationMethodUrl,
            type: "GET",
            data: { id: this.methodConfirmationId(), code: this.appCode() },
            error: err => this.notificationService.showError(JSON.parse(err.responseText).message),
            success: data => {
                this.isInvalidCode(!data)

                if (data) {
                    this.onSaveComplete({ success: true });
                    this.onCloseModal();
                }
            }
        });
    }

    generateKey(callback: () => void) {
        $.ajax({
            url: this.createMfaAppAuthenticationMethodUrl,
            type: "GET",
            data: { nameMethod: this.methodName },
            error: err => this.notificationService.showError(JSON.parse(err.responseText).message),
            success: data => {
                this.accountName(data.account);
                this.secretKey(data.manualEntryKey);
                this.methodConfirmationId(data.methodConfirmationId);
                this.qrCodeImageUrl(data.qrCodeImageUrl);
                callback();
            }
        });
    }

    init() {
        ko.applyBindings(this, this.rootElement.get(0));
    }

    onCloseModal() {
        (this.rootElement as any).modal('hide');
    }

    clearValidation() {
        const errors = ko.validation.group(this);
        errors.showAllMessages(false);
    }

    validate() {
        const errors = ko.validation.group(this, {
            deep: true,
            observable: true,
        });
        return errors().length === 0;
    }

    collapseContainerCodes() {
        this.showContainerCodes(true);
    }

    copyAccountName() {
        navigator.clipboard.writeText(this.accountName());
        this.notifyCopied("Account name");
    }

    copySecretKey() {
        navigator.clipboard.writeText(this.secretKey());
        this.notifyCopied("Secret key");
    }

    private notifyCopied(what: string) {
        this.notificationService.showInfo(`${what} copied successfully`);
    }
}

